var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8974_18521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 6.2168V9.25647",
    stroke: "#333333",
    strokeWidth: 0.653521,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7109 6.2168V9.25647",
    stroke: "#333333",
    strokeWidth: 0.653521,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.97938 8.22634C5.28729 8.22634 5.53689 7.97674 5.53689 7.66884C5.53689 7.36093 5.28729 7.11133 4.97938 7.11133C4.67148 7.11133 4.42188 7.36093 4.42188 7.66884C4.42188 7.97674 4.67148 8.22634 4.97938 8.22634Z",
    stroke: "#333333",
    strokeWidth: 0.653521
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73134 8.22634C10.0392 8.22634 10.2888 7.97674 10.2888 7.66884C10.2888 7.36093 10.0392 7.11133 9.73134 7.11133C9.42343 7.11133 9.17383 7.36093 9.17383 7.66884C9.17383 7.97674 9.42343 8.22634 9.73134 8.22634Z",
    stroke: "#333333",
    strokeWidth: 0.653521
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62091 3.7961H12.0909V3.14258H2.62091V3.7961ZM12.4177 4.12286V11.3481H13.0712V4.12286H12.4177ZM12.0909 11.6748H2.62091V12.3283H12.0909V11.6748ZM2.29414 11.3481V4.12286H1.64062V11.3481H2.29414ZM2.62091 11.6748C2.44044 11.6748 2.29414 11.5285 2.29414 11.3481H1.64062C1.64062 11.8895 2.07951 12.3283 2.62091 12.3283V11.6748ZM12.4177 11.3481C12.4177 11.5285 12.2714 11.6748 12.0909 11.6748V12.3283C12.6323 12.3283 13.0712 11.8895 13.0712 11.3481H12.4177ZM12.0909 3.7961C12.2714 3.7961 12.4177 3.9424 12.4177 4.12286H13.0712C13.0712 3.58147 12.6323 3.14258 12.0909 3.14258V3.7961ZM2.62091 3.14258C2.07951 3.14258 1.64062 3.58147 1.64062 4.12286H2.29414C2.29414 3.9424 2.44044 3.7961 2.62091 3.7961V3.14258Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49313 1.10742H7.2168V3.31809H7.49313V1.10742Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81874 0.690619C7.81874 0.945831 7.61185 1.15272 7.35664 1.15272C7.10142 1.15272 6.89453 0.945831 6.89453 0.690619C6.89453 0.435407 7.10142 0.228516 7.35664 0.228516C7.61185 0.228516 7.81874 0.435407 7.81874 0.690619Z",
    stroke: "#333333",
    strokeWidth: 0.457465
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8974_18521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipy);
export default __webpack_public_path__ + "static/media/zipy.d45dbffe61426f1dea6dafc01d768dbd.svg";
export { ForwardRef as ReactComponent };